import * as React from 'react';
import {connect} from 'react-redux';

import type {NutshellState} from '../../store';

import {openComposerWithId, promptOverrideMinimizedEmail} from './email-composer-actions';
import {getWasMinimizedForEntityId} from './email-composer-selectors';

function mapStateToProps(state: NutshellState): StateProps {
    return {
        minimizedForEntityId: getWasMinimizedForEntityId(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onSendEmailClicked: (entityId: string) => {
            dispatch(openComposerWithId(entityId));
        },
        onPreventOpeningNewEmail: (entityId: string) => {
            dispatch(promptOverrideMinimizedEmail(entityId));
        },
    };
}

type OwnProps = {
    buttonNode: HTMLElement;
    entityId: string;
};

type StateProps = {
    minimizedForEntityId: string | null | undefined;
};

type DispatchProps = {
    onSendEmailClicked: (entityId: string) => void;
    onPreventOpeningNewEmail: (newEntityId: string) => void;
};

type Props = OwnProps & StateProps & DispatchProps;

export class TimelineSendEmailButtonComponent extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.buttonNode.onclick = this.handleSendEmailButtonClicked;
    }

    render() {
        return null;
    }

    handleSendEmailButtonClicked = () => {
        if (
            this.props.minimizedForEntityId &&
            this.props.minimizedForEntityId !== this.props.entityId
        ) {
            this.props.onPreventOpeningNewEmail(this.props.entityId);
        } else {
            this.props.onSendEmailClicked(this.props.entityId);
        }
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const TimelineSendEmailButton = connector(TimelineSendEmailButtonComponent);
